// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__DA-jx","inner":"Footer_inner__1c5mx","nextIcon":"Footer_nextIcon__UFy8p","innerLeft":"Footer_innerLeft__2gnjE"};